"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Campaign = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (store.campaign
        ? (react_1.default.createElement("div", { className: "estimateForm-Campaign_Wrapper" },
            react_1.default.createElement("div", { className: "estimateForm-Campaign_InputWrapper" },
                react_1.default.createElement("input", { type: "checkbox", name: "joining_campaign", value: store.campaign.id, className: "estimateForm-Campaign_CheckBox" }),
                react_1.default.createElement("span", { className: "estimateForm-Campaign_Name" },
                    "\u300C",
                    store.campaign.name,
                    "\u300D\u306B\u5FDC\u52DF\u3059\u308B")),
            store.campaign.description &&
                react_1.default.createElement("p", { className: "estimateForm-Campaign_Description" }, store.campaign.description),
            store.campaign.url &&
                react_1.default.createElement("p", { className: "estimateForm-Campaign_DetailUrl" },
                    react_1.default.createElement("span", null, "\u8A73\u7D30\u306F"),
                    react_1.default.createElement("a", { href: store.campaign.url, target: "_blank", rel: "noopener noreferrer" }, "\u3053\u3061\u3089"),
                    react_1.default.createElement("span", null, "\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002")))) : null);
});
exports.default = Campaign;
